import React from "react";
import { CheckOutlined, ToolOutlined, CheckCircleFilled, InfoCircleFilled } from "@ant-design/icons";
import moment from "moment";
import { ButtonItem } from "../../../../Components/Items";
import { SOPORTE_TEMA } from "./fasesSoporte";

const AccionesSubido = ({ ticket, onResponder, guardando = false, compacto = false }) => {
  if (!ticket || ticket.fase !== "subido") return null;

  const marco = {
    border: `1px solid ${SOPORTE_TEMA.border}`,
    borderRadius: 6,
    padding: compacto ? "8px 10px" : "10px 12px",
    backgroundColor: SOPORTE_TEMA.bg,
  };

  if (ticket.respuestaCliente) {
    const cumplio = ticket.respuestaCliente === "si";
    const color = cumplio ? "#52c41a" : "#faad14";
    const Icono = cumplio ? CheckCircleFilled : InfoCircleFilled;

    return (
      <div style={{ ...marco, borderLeft: `3px solid ${color}`, display: "flex", gap: 8, alignItems: "center" }}>
        <Icono style={{ color, fontSize: 15, flexShrink: 0 }} />
        <div style={{ fontSize: 12, color: SOPORTE_TEMA.textPrimary }}>
          {cumplio ? "Confirmaste que este reporte se cumplió." : "Indicaste que este reporte requiere un ajuste adicional."}
          {ticket.fechaRespuestaCliente && (
            <span style={{ color: SOPORTE_TEMA.textSecondary }}>
              {" · "}
              {moment(ticket.fechaRespuestaCliente).format("LL")}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={marco}>
      <div style={{ fontSize: 13, fontWeight: 600, color: SOPORTE_TEMA.textPrimary, marginBottom: 8 }}>
        ¿Se cumplió bien lo que pedías en este reporte?
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <ButtonItem verde icon={<CheckOutlined />} loading={guardando} onClick={() => onResponder("si")}>
          Sí
        </ButtonItem>
        <ButtonItem naranja icon={<ToolOutlined />} loading={guardando} onClick={() => onResponder("no")}>
          Requiere ajuste
        </ButtonItem>
      </div>
    </div>
  );
};

export default AccionesSubido;
